<script>
import { CHAT_BLOCK_LOG_ITEM_TYPE_BLOCK   } from '../model/player-chat-block-log';
import { CHAT_BLOCK_LOG_ITEM_TYPE_UNBLOCK } from '../model/player-chat-block-log';

import PlayerChatBlockPreview   from './PlayerChatBlockPreview.vue';
import PlayerChatUnblockPreview from './PlayerChatUnblockPreview.vue';

export default {
  name: 'PlayerChatBlockLogItem',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    object: {
      type: Object,
      required: true,
    },

    userMap: {
      type: Map,
      required: true,
    },
  },

  render(createElement) {
    const componentType = getComponentType(this.object.type);
    const data = {
      props: {
        playerId: this.playerId,
        object:   this.object,
        userMap:  this.userMap,
      },
    };
    return createElement(componentType, data);
  },
}

function getComponentType(purpose) {
  switch(purpose) {
    case CHAT_BLOCK_LOG_ITEM_TYPE_BLOCK:
      return PlayerChatBlockPreview;
    case CHAT_BLOCK_LOG_ITEM_TYPE_UNBLOCK:
      return PlayerChatUnblockPreview;
  }
  return null;
}
</script>
